let en = {
  "common": {
    //公共翻译
    "returnButton": "Back",
    "okButton": "OK",
  },
  //ホーム
  "home": {
    "myLesson": "My Course",
    "learningAnalysis": "Learning Analysis",
    "courseConditions": "Course Conditions",
    "learningProcess": "Learning Progress",
    "performanceAnalysis": "Performance Analysis",
    "liveMessage": "Live Class",
    "notLogin": "Login",
    "faceIn": "Face-In",
    "accountIn": "Account In",
    "accountOrEmail": "Email/UserID",
    "passwordDigits": "Password(8-16 Digits)",
    "rememberMe": "Save login information",
    "forgetPass": "Forget Password",
    "identifyStart": "Identify Start",
    "immediateLogin": "Login",
    "courseName": "Course Name",
    "teachingTime": "Teaching Date",
    "status": "Status",
    "clickJump": "Participation",
    "userProtocol": "《Privacy Policy》",
    "operation": "Operation Manual",
    "faq": "FAQ",
    "service": "Searvice agreement",
    "policy": "Privaccy policy",
    "keepLogin": "Keep me logged in",
    "support": "Support",
    "schcourseConditions": "受講状況(スケジュール)", 		 
	  "schperformanceAnalysis": "成績状況(スケジュール)",
    "welcome": "Welcome to Study-arts!",
    "selectCompanyTitle": "Please select the company you want to sign in to.",
  },
  //错误显示画面
  "err": {
    "err1": "An error occurred while screen moving.",
    "err2": "Please log out, close your browser.Then try again for a while.",
    "err3": "Plase contact to StudyArts support center if the error is not resolved.",
      "err4": "There was a problem accessing the data. Contact the Study Arts team for more information",
      "revertErr": "Back to home page",
   },
   //学習詳細状況
   "aicourse": {
      "beginLearn": "Start",
      "endLearn": "End",
      "timeLength": "Term",
      "week": "Week",
      "weekPlan": "Week Plan",
      "hoursPre": "Hours Schedule",
      "beforeKnowledge": "Required Knowledge",
      "distinguish": "Distinguish",
      "courseLanguage": "Language",
      "classification": "Category",
      "category": "Category"
   },
   //
   "courseScoreStatistics": {
      "beginLearningTime": "Learning Start Time",
      "validityPeriod": "Validity Period",
   },
   //community
   "community": {
      "content": "Nothing",
      "dataNone": "Incorrect problem doesn't exist yet",
      "down": "Download",
   },
   //成績分析
   "scoreStatistics": {
      "performanceAnalysis": "Performance Analysis",
      "schPerformanceAnalysis": "修了試験成績状況(スケジュール)",
      "courseName": "Course Name",
      "courseNameInput": "Please enter Course Name",
      "validityPeriod": "Valid Period",
      "chooseDate": "ChooseDate",
      "search": "Search",
      "studentsCounst": "Number of students",
      "myScore": "score",
      "aveScore": "Average score",
      "maxPoint": "highscore",
      "minPoint": "Lowest point",
      "point90": "Pass",
      "point80": "failure",
      "personCount": "Number of people",
      "proportion": "rate",
      "passPercent": "Passing reference point",
      "judge": "Pass judgment",
      "message1": "Best Score：",
      "message2": "Point",
      "message3": "※Platform course is out of grade analysys",
      "result": "Result",
      "testName": "Test name",
      "finalExam": "Final exam",
   },
   "curriculum": {
      "exam": "Final exam",
      "errorCollection": "Wrong problem collection",
      "questionnaire": "Questionnaire survey",
      "scoreStatistics": "Grade analysis",
      "gotoLive": "Live lecture",
      "question": "questionnaire",
      "covenant": "written oath",
      "thi__giua__ki": "Midterm exam"
   },
   "curriculumExam": {
      "listExam": "List Exams",
      "passExam": "Pass Exam",
      "failExam": "Fail Exam",
      "doNotExam": "Don't Exam",
      "rank": "Rank",
      "doingExam": "you cannot confirm your grades during the exam"
   },
   //試験はじめページ
   "examBegins": {
      "center": "Examination Center",
      "notice": "Precautions for the test",
      "introduce": "Test description",
      "first": "This test is to confirm the degree of understanding of the content (knowledge) learned in the course you participated in.",
      "second": "Exam response formats include multiple-choice format (choice format, multiple choice), fill-in-the-blank format, and descriptive format.",
      "third": "This test should be regarded as the final test after all the quizzes in each chapter have been cleared, and please clear all the quizzes before taking the test.",
      "rule": "Exam rules",
      "one": "Please answer all the questions within the time limit. The test will end automatically when the time limit is reached.",
      "two": "Questions without an answer are considered incorrect.",
      "three": "After answering all the questions, please check that the answers are correct and then click the 'Submit Exam' button to complete the exam.",
      "remain": "Number of exams",
      "current": "Most recent score",
      "highest": "Highest score",
      "begin": "Test start",
      "giveUp": "Stop the exam",
      "notice_exam": "試験における注意事項",
      "notice_midterm": "試験における注意事項",
      "type": "Display Type",
      "notFull": "Show each sentence",
      "full": "Show all",
      "changeTypeShow": "表示モード変更"
   },
   "examResume": {
      "resume": "Exam history",
      "point": "Test score",
      "time": "test time",
      "jump": "To class page",
   },
   "detailExam": {
      "finalExam": "Final exam",
      "seconds": "Seconds",
      "minutes": "Minutes",
      "fullMark": "Full Mark",
      "standardMark": "Standard Mark",
      "yourMark": "Your Mark",
      "pass": "Pass",
      "fail": "Fail",
      "viewDetailWrong": "View Detail Wrong Answers",
      "viewChapter": "Mark of each Chapter",
      "totalRightAnswer": "Total right answer",
      "totalScore": "Total Mark"
   },
   //間違った問題集
   "errorBook": {
      "errorBook": "Incorrect problem collection",
      "prve": "Previous page",
      "next": "next page",
      "answerInput": "Please enter your answer ...",
      "answer": "Answer",
      "rightAnswer": "Correct answer",
      "answerAnalysis": "Answer analysis",
      "download": "Incorrect problem export",
      "remove": "Remove the incorrect problem",
      "confirmMessage": "Do you really want to delete from the Incorrect question list？",
   },
   "previewBook":{
      "previewBook": "Final exam questions",
   },
   "active": {
      "goHome": "Top page",
   },
   //
   "email": {
      "title": "Password reset",
      "email": "Please enter your e-mail address",
      "emailWarning": "※ For customers who use the system with a user ID, this function cannot be used. If you want to reset your password, please contact the administrator who issued your user ID.",
      "placeholder": "Please enter your e-mail address",
      "confirmplaceholder": "Please enter your e-mail address(confirm)",
      "confirm": "OK",
      "message": "Entered email address doesn't match each other",
   },
   "register_email": {
      "title": "Password reset mail sent",
      "message": "Sent mail to your registered email address.Please access the URL described in the mail and then change your password.",
      "passwordResetSuccess": "Password reset. Please login again.",
      "timeout": "The time of password reset URL has expired!. Please send another password reset mail through ' Password reset here '",
      "checkMessage": "Password doesn't match",
   },
   "courseList": {
      "courseName": "Course name",
      "courseNameInput": "Please enter the course name",
      "validityPeriod": "Course validity period",
      "chooseDate": "Date selection",
      "to": "～",
      "no": "No",
      "operation": "operation",
   },
   "courseProgress": {
      "learningProcess": "Progress rate",
      "search": "Search",
      "learnBeginDate": "Course start date",
      "complete": "Number of completed chapters",
      "uncomplete": "Number of remaining chapters",
      "examhistory": "Exam history",
      "isquestion": "status",
      "look": "display",
   },
   "personSet": {
      "changePass": "Change Password",
      "personInfo": "personal information",
      "messageCenter": "Information Center",
      "changeFace": "Headshot correction",
      "chooseImg": "Image selection",
      "save": "Save",
      "off": "Cancel",
      "confirm": "Confirmation of correction",
      "currentPass": "Current password",
      "newPass": "New password",
      "repeatPass": "Duplicate password",
      "notMessage": "No message",
      "noticeTime": "Notification time",
      "noticeTittle": "Notification content",
      "status": "status",
      "unread": "Unread",
      "read": "Already read",
      "userName": "User name",
      "email": "Email",
      "mobile": "mobile phone",
      "change": "Fix",
      "passwordNotNull": "New password is a required entry",
      "oldPasswordIncorrect": "Former password fraud",
      "passwordChangeFail": "Password correction failed",
      "imgSuccess": "I modified my profile picture!",
      "placeholder": "Please enter 8 to 16 characters including uppercase and lowercase letters, numbers.",
      "defaultLanguage": "Default system language",
      "imageError": "サポート拡張子（gif,jpeg,jpg,png,bmp）を選択してください。",
      "birthday": "Birthday",
      "occupation": "Occupation",
      "synopsisUser": "self-introduction",
      "synopsisNonUser": "You haven't introduced yourself yet.",
      "enterName": "Please enter your name.",
      "editInfoUser": "EDIT YOUR PERSONAL INFORMATION",
      "enterSex": "Select your gender.",
      "enterMobile": "Please enter your contact information.",
      "enterJob": "Please enter your occupation.",
      "enterSynopsis": "Please enter your personal information.",
    "personInfoSanritsu": "personal information"
   },
   "contactUs": {
      "contactUs": "Contact Us",
      "email": "mail address",
      "send": "Send",
      "problem": "Please enter your question",
      "sucess": "Successful transmission",
      "sure": "Authorization number",
      "sorry": "We are happy to answer your questions and we deeply apologize if any of our products and services cause any inconvenience.",
      "gohome": "Top page",
      "faild": "Sending failure",
      "sever": "I'm sorry! If the server is busy, please try again.",
      "resend": "resend",
   },
   //コース一覧ページ
   "schoolBusiness": {
      "sloganFour": "My Courses",
      "all": "All",
      "introduceThree": "Don't miss out on business",
      "introduceFour": "Enroll in a course and build your best future, today.",
      "beginLearn": "Start learning",
      "elective": "Recommended",
      "generalCourse": "コース",
      "privateCourse": "コースセット",
   },
   "search": {
      "keyWord": "Please enter a keyword",
      "result": "No search results",
   },
   "studySituationList": {
      "count": "Attendance statistics",
      "validityPeriodStart": "Valid start time",
      "validityPeriodEnd": "Valid end time",
      "distinguish": "Classification",
      "studentEndDate": "Last study date",
      "guarantee": "Pledge",
      "certificate": "Certificate",
      "notRaised": "not submit",
      "raised": "submit",
   },
   "schStudySituationList": {
      "count": "受講コース進捗状況(スケジュール)",
      "validityPeriodStart": "開始予定日",
      "validityPeriodEnd": "完了予定日",
      "learnBeginDate": "受講開始日",
      "learnEndDate": "受講完了日",
      "learningProcess": "学習進捗率",
      "completionStatusFlag": "ローカル完成状態",
      "offlineCompleteTime": "完了日",
      "isDelay": "遅延状況",
      "finish": "完成",
      "undone": "未完成",
      "delay": "遅延あり",
      "noDelay": "遅延なし",
   },
   "task_answer": {
      "answerCommit": "Scoring",
      "examCommit": "Exam submission",
      "answer": "Answer",
   },
   "task_result": {
      "prev": "Prev",
      "next": "Next",
      "wrong": "Illegal answer",
      "reght": "Answer correct",
      "answer": "See answer",
      "analysis": "Question analysis",
      "question": "Question",
      "unShowAnswer": "本問題の解答を見ることができません。",
   },
   "rePassword": {
      "newPassword": "(8-16 bits) New password",
      "repeact": "(8-16 bit) Password confirmation",
      "confirm": "Confirm",
   },
   "read": {
      "catalogue": "table of contents",
      "note": "Note",
      "chat": "Comments",
      "tips": "Write a note about this course here.",
      "login": "Please login",
      "save": "Save",
      "jump": "No.",
      "page": "To page",
      "prev": "Prev",
      "next": "Next",
      "returnCatalogue": "To table of contents ",
   },
   "week": {
      "status": "Status",
      "exercise": "Small test",
      "score": "Score",
      "undone": "Unstudied",
      "done": "Studied",
      "studing": "Studying"
   },
   "questionnaire": {
      "questionnaire": "Questionnaire survey",
      "contentInput": "Please enter the content",
      "submit": "Confirmation",
      "tempSave": "Temporarily Save",
      "tempSaveHint1": "Do you want to temporarily save survey results?",
      "tempSaveHint2": "Warning: Temporarily saved content will be lost if you switch browsers or devices.",
      "noticeSuccess": "Save successfully.",
   },
   "js": {
      "confirm": "OK",
      "quite": "Do you really want to log out?",
      "hint": "Confirmation",
      "cancel": "Cancel",
      "userNameNull": "User name is a required input item",
      "email": "Please enter your e-mail address",
      "formatWrong": "Email address fraud",
      "passwordNull": "Please enter your password information!",
      "passwordFormat": "Please enter an 8- to 16-digit password mixed with uppercase letters, lowercase letters, and numbers. * Special characters other than 「_ +-= * #% $」 can not be applied.",
      "repeatPassword": "Password confirmation is a required input item",
      "different": "Passwords do not match",
      "service": "Please check 'User Service Contract'",
      "account": "Please enter your account information!",
      "password": "Please enter your password information!",
      "beginLearning": "Are you sure you want to get started?",
      "dataNone": "No information",
      "jumpToexam": "Please complete the course before taking the exam.",
      "examDataNone": "No exam information!",
      "certificateDataNone": "Course completion certification has not been registered,yet.",
      "jumpToQuestion": "Please complete the course before conducting the survey.",
      "jumpToErrorBook": "Please finish the course first to use the wrong question book!",
      "loginPlease": "Please login",
      "lastExam": "The recent exam grades are still incomplete and cannot be re-examined temporarily!",
      "no": "No.",
      "placeholder": "Enter here",
      "examOver": "At the end of the exam, the exam form will be submitted automatically.",
      "emailNone": "Email address does not exist!",
      "sendSuccess": "Successful transmission!",
      "returnHome": "Top page",
      "problemInput": "Please enter your question",
      "submitConfirm": "Do you want to send?",
      "noLive": "There is no live course!",
      "PleaseLogin": "I haven't saved my notes",
      "submitHint": "We are sorry, but please log in to the system before using.",
      "nonull": "Buy a course",
      "nocorrect": "Saved successfully",
      "mostPage": "Please do not fill in unless you write everything properly. Thank you for your feedback.",
      "leastPage": "Regarding the questionnaire survey, there are some blanks, so please answer all the items.",
      "saveNotes": "The current class has expired",
      "unSaveNotes": "The correction of the previous test is not finished yet. I can't take the exam for a while!",
      "dontSave": "The maximum number of pages has been exceeded!",
      "wordMore": "Confirm: Save note",
      "saveSuccess": "Cancel: Do not save notes",
      "PleaseLogin": "I haven't saved my notes",
      "nonull": "Buy a course",
      "systemError": "A system error occurred!",
      "userNotExist": "The user does not exist!",
      "passwordWrong": "The password is in correct!",
      "passErrorTimer": "You mistook password 5 times. This account will have been locked for ten minutes. ",
      "passLock": "This account was locked for ten minutes. Please check it out later.",
      "failMatch": "Unable to authenticate user, please try again after adjustment",
      "faceFail": "Face recognition failed",
      "AccecpProtocol": "Please read and agree to the contract and privacy policy",
      "submitConfirmTest": "Submit the final exam. Is it OK?",
      "submitConfirmExam": "Are you sure you want to submit the midterm exam?",
      "submitSuccessExam": "You have completed the midterm exam. Please click on the “Achievements” button to see the results?",
      "submitSuccessTest": "Final exam was submitted. Please check the results in 'Grades'.",
      "submitSuccessTask": "You submit the small test. Please check the resulte on 'Score rate'.",
      "uncheckMessage": "There is a pledge not confirmed yet. Please check and submit again.",
      "networkErr": "ネットワーク通信エラーが発生しました。",
      "confirmSaveNotes": "Your note has changed. Do you want to save the current note?",
      "confirmJoinCourseOnline": "Would you like to take this course?",
      "alertCourseOnlineEnd": "Sorry this course has ended.",
      "exerciseMsg": "小テストを提出します。よろしいでしょうか。",
    "commonCourseMessage":"本コースのグローバルコース「{1}」を受講しています。本コースを受講開始すると、既に受講したグローバルコース「{2}」の受講結果がクリアされます。よろしいですか？",
    "downloadPdfFalse": "Download the lost invoice. You need to re-enroll in the course to proceed with the invoice export.",
    "registerApplyCourseFalse": "The course registration is failed. You need to re-register for the course to issue an invoice."
   },
   "new": {
      "title1": "Recommended course",
      "title2": "Configuration",
      "title3": "More",
      "title4": "Replace course",
      "title5": "search results",
      "title6": "all",
      "title7": "End",
      "title8": "Live",
      "title9": "not started",
      "title10": "select all",
      "title11": "Deselect all",
      "title12": "Note output",
      "title13": "Question list",
      "title14": "Total number of questions",
      "title15": "Number of answered questions",
      "title16": "Usage time",
      "title17": "Warning <br> The default password is used as it is! Be sure to change your password to enhance security.",
      "title18": "The new password and the original password match!",
      "title19": "Termination application",
      "title20": "Start learning",
      "title21": "Completion of learning",
      "title22": "Content learning",
      "showCompletedCourse": "Including completion course",
      "title24": "Perfect score",
      "title25": "Edit",
      "title26": "I'm sorry, I haven't taken the exam yet, so I can't confirm my grades.",
      "title27": "I'm sorry, I haven't scored the exam yet, so I can't confirm my grades.",
      "title28": "Current password is a required entry item",
      "title30": "There is unfinished content!",
      "title31": "Stop the quiz",
      "title32": "Stop the quiz. Is it OK?",
      "title33": "questionnaire",
      "title34": "Application",
      "title35": "Submit a termination application. Is it OK?",
      "title36": "I have submitted a termination application. Please confirm the application result by pressing 'End application' again.",
      "title37": "I will take the exam again. Is it OK?",
      "title38": "(* Pass will be judged based on the score of the final exam)",
      "title39": "transition",
      "title40": "I can't access it because the course hasn't started yet.",
      "title41": "You cannot access the course because it has not expired. Please contact the administrator.",
      "title42": "There are unanswered questions, but I will submit the quiz as it is. Is it OK?",
      "title43": "Password change successful, please login again.",
      "title44": "Course period",
      "title45": "None",
      "title46": "Please submit a pledge before the questionnaire.",
      "title47": "Please complete the course before the questionnaire.",
      "title48": "Please complete the 'final exam' before the questionnaire.",
      "title49": "Please complete the course before the questionnaire.",
      "title50": "Progress confirmation",
      "title51": "Student name",
      "title52": "Affiliation district",
      "title53": "Utilization organization",
      "title53_1": "Utilization organization",
      "title54": "Affiliation organization",
      "title54_1": "Affiliation organization",
      "title55": "Departure date",
      "title56": "Course division",
      "title57": "Learning progress",
      "title58": "Latest result",
      "title59": "Final exam pass judgment",
      "title60": "Learning start date",
      "title61": "Learning end date",
      "title62": "Number of completed chapters",
      "title63": "Number of unfinished chapters",
      "title64": "written oath",
      "title65": "questionnaire",
      "title66": "Completion application",
      "title67": "Including retirees",
      "title68": "Student learning progress",
      "title69": "Please enter the student's name",
      "title70": "EXCEL file export",
      "title71": "Please select the utilization organization",
      "title72": "Please select your organization",
      "title73": "Please select a course category",
      "title74": "From 0",
      "title75": "to 100",
      "title76": "Please select the final exam pass judgment",
      "title77": "Range of progress",
      "title78": "Please select a completion application",
      "title79": "export",
      "title80": "Please select your belonging area",
      "title81": "The course has not been locked. the 'exam' function is not yet available.",
      "title82": "This course was not locked yet. 'Questionary' can not be started because the contents may be changed. Please wait until lock was done.",
      "title83": "This course was not locked yet. 'Written auth' can not be started because the contents may be changed. Please wait until lock was done.",
      "title85": "Clear",
      "title86": "Notification",
      "title87": "You must finish this video before moving to the next page !",
      "title88": "There is no content in this chapter!",
      "title89": "This content isn't available right now. Please try again later !",
      "title90": "You cannot see the details of the course because you are not the teacher in charge of this course!",
      "title91": "Dependent course {0} has not been completed yet, so you cannot access this course!",
      "title92": "Please start studying this course after {1} days since completing the dependent course {0}.",
      "title93": "Sorry, you can't access this page yet because you are not in charge any courses!",
      "title94": "Sorry, you cannot view the details as this student hasn't taken this course yet!",
      "title95": "Today",
      "title96": "Sorry! There is no midterm exam. So please come back later!",
      "title97": "You can't take the midterm exam because you're taking the final exam!",
      "title98": "You can't take the final exam because you're taking the midterm exam!",
      "title99": "You are taking the final exam. Would you like to continue?",
      "title100": "You are taking the midterm exam. Would you like to continue?",
      "title101": "You are taking another midterm exam. Please complete before starting this midterm exam!",
      "title102": "Sorry, you cannot take this mid-term exam since there is no question in this test!",
      "title103": "Incorrect answers",
      "title104": "You cannot do the excercise because you haven't complete the content.",
      "title105": "You cannot take the final exam because your exercises do not meet the pass rate.",
      "title106": "You cannot start this course because you are not a student of this course.",
      "title107": "You cannot close this course because you are not a student of this course.",
      "title108": "You can't see the details of this course because no content has been registered for this course yet.",
      "title109": "This account has been disabled!",
      "title110": "You cannot complete this course because you are not a student of the course.",
      "title111": "学習進捗_",
      "title112": "Because this student has never taken the exam, the exam results file cannot be exported.",
      "title113": "Because there is no students took the exam in this course, the exam results file cannot be exported.",
      "title114": "This student is not set as a live lecture student and cannot export attendance information. ",
      "title115": "問題集",
      "title116": "一覧",
      "title117": "Popular course",
      "title118": "Frequently selected course",
      "title119": "Latest course",
      "title120": "おすすめコース",
      "title121": "USD",
      "title122": "あなたが試験でとれた点数は",
      "title123": "不正解問題の詳細",
      "title124": "確認",
      "title125": "試験は採点中です。試験が採点された後、[成績]ボタンを押下してを確認してください。",
      "title126": "再確認必要問題一覧",
      "title127": "再確認",
      "title128": "再確認必要問題一覧",
      "title129": "表示",
      "title130": "最新コース",
      "title131": "Popular courses",
      "title132": "おすすめコース",
      "title133": "カテゴリー別コース",
      "title134": "配置",
      "title135": "人気",
      "title136": "高い評価",
      "title137": "高い順",
      "title138": "安い順",
      "title139": "最新",
      "title140": "コースの配置",
      "title141": "名",
      "title142": "カートに追加",
      "title143": "お申し込み",
      "title144": "価格",
      "title145": "time",
      "title146": "時間",
      "title147": "number of sections",
      "title148": "割引有効期間",
      "title149": "受講者数",
      "title150": "コース詳細内容",
      "title151": "目次",
      "title152": "空カート",
      "title153": "コースの価格",
      "title154": "セクション数",
      "title155": "合計",
      "title156": "関連コース",
      "title157": "本コースは既にカートに追加されました。",
      "title158": "受講者のコメント",
      "title159": "受講者の評価",
      "title160": "本コースについての評価",
      "title161": "送信",
      "title162": "申込",
      "title163": "学習開始",
      "title164": "振込",
      "title165": "振込先の情報",
      "title166": "口座番号",
      "title167": "銀行名",
      "title168": "合計",
      "title169": "振込内容",
      "title170": "氏名",
      "title171": "メールアドレス",
      "title172": "電話番号",
      "title173": "注意：　振り込む際、Study-artsの振込内容に記載されている振込番号を正確にご記入ください。",
      "title174": "申し込んだコースの情報",
      "title175": "割引前の価格",
      "title176": "割引価格",
      "title177": "購入金額",
      "title178": "コースのお申込みを受け付けました！",
      "title179": "You have successfully registered for the course on Study-arts. As soon as we check the information, we will send you an email with login information.",
      "title180": "念のため、振込内容（振込番号）をメモしておいてください。",
      "title181": "ホームページに戻る",
      "title182": "お申し込み",
      "title183": "紹介コース一覧",
      "title184": "このライブ講義に参加した受講者がいないため、出席情報のファイルをエクスポートできません。",
      "title185": "データがない為、ファイルをエクスポートすることができません。",
      "title186": "HOTコース",
      "title187": "別のデバイスで試験を受けたため、最初からやり直しないといけません。",
      "title188": "このデバイス・ブラウザで試験を受けたい場合は最初から始める必要があります。",
      "title189": "全てのカテゴリー",
      "title190": "共通カテゴリー",
      "title191": "あなたの提出は成功しませんでした。ネットワーク接続をもう一度確認してください。または、直接お問い合わせください",
      "title192": "該当コースは既にスケジュールに存在しています。スケジュールコースを確認してください。",
      "title193": "不正解問題集",
      "title194": "この試験では、この受講者の不正解はありませんでした。",
      "title195": "当コースは既にカートに追加されました。",
      "title196": "購入を続ける",
      "title197": "当コースについての評価はまだありません。",
      "title198": "コメントを入力してください。",
      "title199": "氏名を入力してください。",
    "title200": "Please enter your email.",
      "title201": "電話番号を入力してください。",
    "title202": "Please enter the correct phone number format",
      "title203": "隠れる",
      "title204": "振込番号",
      "title205": "振込金額",
      "title206": "申込情報出力",
      "title207": "お気に入り",
      "title208": "X",
      "title209": "不正解問題は全て削除されました！",
      "title210": "試験の実施中にブラウザやデバイスを切り替えた場合、答えた内容は保存されません。",
      "title211": "選択コース",
      "title212": "Course introduction",
      "title213": "Introduction of teacher",
      "title214": "無料",
      "title215": "無料コース",
      "title216": "「修了試験」を完了した後、「請求書」を実行してお願いします。",
      "title217": "アンケートを提出する前にアンケート内容確認のチェックボックスをオンにしてください。",
      "title218": "この受講者の出席をとりますが、よろしいですか？",
      "title219": "注意",
      "title220": "Featured course",
      "title221": "All categories",
      "title222": "Course Finish",
      "title223": "Bank accounts",
      "title224": "Selected course",
      "title225": "Course search",
      "title226": "Other banks",
      "title227": "filter",
      "title228": "Registration confirmation",
      "title229": "Delete",
      "title230": "名前",
      "title231": "匿名",
      "title232": "コメントをここに入力してください。",
      "title233": "Study-Arts",
      "title234": "Email/UserID",
      "title235": "Email and Email confirmation do not match.",
      "title236": "Registration consent",
      "title237": "Refusal to register",
      "title238": "Approve",
      "title239": "Refuse",
      "title240": "Preview",
      "title241": "Please enter the correct format for your first and last name",
      "title242": "Please enter correct Mail format",
      "title243": "Mail already exists in the system. Please use another Mail or login to your existing Mail to continue the course registration process.",
      "title244": "This course has been registered.",
      "title245": "Please enter confirmation Mail",
      "title246": "Email",
      "title247": "Email confirmation.",
      "title248": "No",
    "title249": "Required input items have not been entered (where the background is light pink). Please fill out and submit again.",
    "title250": "We have received your application for the StudyArts online course. Please review the application information below, select your application region, and download the invoice.",
    "title251": "Please make the payment promptly according to the payment instructions on the invoice. After the payment is completed, we will send the login information to you via email.",
    "title252": "Applicant's Name:",
    "title253": "Email Address:",
    "title254": "Application Region:",
    "title255": "Area Code:",
    "title256": "Area Name:",
    "title257": "Download invoice",
    "title258": "地域番号",
    "title259": "様",
    "title260": "発行日",
    "title261": "年",
    "title262": "月",
    "title263": "日",
    "title264": "学費請求書",
    "title265": "ご請求金額",
    "title266": "項目",
    "title267": "金額",
    "title268": "コース期間",
    "title269": "①　次のいずれかの支払い方法を選択してください",
    "title270": "WeChat 支払い: WeChat で次の QR コードをスキャンし、この支払い通知をアップロードし、",
    "title285": "送金 者に関する情報を入力してください。リアルタイム為替レート、手数料 1.3%。",
    "title271": "②　海外送金：銀行経由で下記の学校口座に送金してください。",
    "title272": "Pound Sterling",
    "title273": "Name bank:",
    "title274": "Confirm registration information",
    "title275": "Please check the registration information below.",
    "title276": "Please review the application information below, select the application area, and then proceed with the application.",
    "title277": "申込番号",
    "title278": "内訳",
    "title279": "※海外送金に必要な振込手数料は送金者のご負担となります。",
    "title280": "修正不可",
    "title281": "※請求書についてご質問があれば、電話にて下記までお問合せ下さい。",
    "title282": "お問い合わせ番号：",
    "title283": "Course name: ",
    "title284": "The courses you are applying for this time include courses that have been applied for. Please check again to see if there are any errors in the courses you are applying for. ",
    "title290": "If there is no problem after verification and you want to apply as it is, please click the 「Apply」 button.",
    "title289": "However, please note that past application information for this course will be overwritten.",
    "title286": "Apply",
    "title287": "Cancel",
    "title288": "オンライン授業請求書_",
    "title291": "無料",
    "title292": "申込",
    "title293": "Registration confirmation",
    "title294": "Export study progress"
  },
  "manage": {
    "look": "Display",
    "discription": "Overview",
    "students": "List of students",
    "lessons": "List of chapters",
    "detail": "Detail",
    "student": "Student management",
    "lesson": "Lesson management",
    "questions": "List of questions",
    "sex": "gender",
    "lesson_begin": "Unstarted course",
    "lesson_learning": "Studying course",
    "lesson_end": "Completed course",
    "default": "All courses",
    "manage_info": "Information Manage",
    "download": "Download",
    "coursesOnline": "number of students",
    "downloadStudents": "Export studen list",
    "attendance": "Attendance information",
    "presentList": "List of present",
    "absentList": "List of absent",
    "statusAttendance": "Attendance status",
    "present": "Present",
    "absent": "Absent"
  },
  "manage_questions": {
    "questions_id": "Questions ID",
    "questions_content_title": "Content of question",
    "questions_audio": "Audio",
    "questions_video": "Video",
    "questions_image": "Image",
    "questions_created": "Created by myself",
    "chosse_questions": "Please select a question type",
    "chosse_questions_one": "Single choice question",
    "chosse_questions_more": "Multiple choice question",
    "questions_writing": "Descriptive question",
    "chosse_answer_more": "Group of question",
    "chosse_status_questions": "Please select the purpose of the question",
    "questions_exercise": "small test",
    "questions_test": "test",
    "chosse_teacher_create": "Please select teacher create question",
    "chosse_chapter": "Please select a chapter",
  },
  "live_lesson": {
    "hiden": "Hide search area",
    "display": "Display search area",
  },
  "profile": {
    "name": "Student's name",
    "sex": "Sex",
    "email": "Email",
    "statistic": "Statistical analysis",
    "sum_lesson": "Total number of courses",
    "lesson_begin": "Number of unstarted courses",
    "lesson_learning": "Number of studying courses",
    "lesson_end": "Number of completed courses",
    "detail_lesson": "Course details",
    "course": "Course",
    "discription": "Discription",
    "link": "URL link",
    "studyTime": "Participation period",
    "showStatical": "Aggregate information display",
    "jonhLiveCourse": "Number of attendance at live lectures",
    "noJonhLiveCourse": "Number of absenteeism from live lectures ",
  },
  "manage_lesson": {
    "keyWord": "Please enter the course title",
    "lesson": "Chapter",
    "lesson_list": "Course table of contents",
    "total_lesson": "Total number of chapters",
    "total_excercise": "Total number of small test",
    "total_student": "Total number of students taking the course",
    "statistical": "Statistical analysis",
    "time_course": "Course time",
    "teacher_charge": "Teacher in charge ",
    "status_course": "course status",
    "live_lesson": "Studying",
    "not_stater": "Not started yet ",
    "not_open": "Temporarily not open",
    "next_page_details": "Content details",
    "info_course": "Course information",
    "status1": "Unstydied students",
    "status2": "Studying Students",
    "status3": "Studied Students",
    "clear": "Reset",
    "choose_date": "Please select a question creation date",
    "static": "Exam results",
  },
  "manage_student": {
    "lesson_normal": "study sourse",
    "lesson_test": "exam course",
    "type": "Classification",
    "time": "period",
    "count_of_students": "Number of students",
    "teacher": "Teacher",
    "job": "Role",
    "mobile": "Contact information",
    "to_chuc": "Using organization",
    "level": "Grade",
    "age": "Date of birth",
    "area": "Nation (Language)",
    "chi_nhanh": "Branch",
    "male": "male",
    "female": "female",
    "charge": "In charge",
    "not_charge": "Not in charge",
    "status": "Status",
    "person_charge": "Responsible person",
    "me": "myself",
    "not_me": "others",
    "lesson_unlocked": "Have not attended the course",
    "lesson_locked_not_study_end": "Studying",
    "lesson_study_end_not_exam": "Completed the lesson content",
    "lesson_exam_doing": "Conducting the exam",
    "lesson_exam_end": "Incomplete exam scoring",
    "lesson_unpass": "Fail",
    "lesson_pass": "Pass",
    "lesson_tuyet_doi": "Perfect score",
    "lesson_end": "Completed",
    "app_sp": "Application and support",
    "keyWord": "Enter the title or content of the course",
    "exam_not_me": "User is not a student of the course",
    "live_time": "Live time",
    "hour": "hour",
    "minute": "minute",
    "export": "Results Export",
    "exportDiligent": "Export attendance information",
    "noJonhLive": "Non-participation ",
  },
  "statictical" : {
    "chapter_status": "Chapter Status",
    "total_chapter": "Total number of Chapters",
    "excercise_status": "Excercise Status",
    "total_excersice": "Total number of Excercises",
    "completed": "Completed",
    "unstudied": "Unstudied",
    "studying": "Studying",
    "scored": "Scored",
    "unscored": "Unscored",
    "waiting_scoring": "Waiting for scoring",
  },
  "mid_term": {
    "mid_term": "Midterm exam",
    "choose_mid_term": "Please select one mid-term exam",
  },
  "wrong_book": {
    "examList": "Exam list"
  },
  "preview": {
    "examList": "Exam list preview"
  },
  "comments": {
    "commentName": "Comment list",
    "titleStatus": "Including comments in unstudied courses",
    "content": "Related content",
    "countConv": "Number of comments",
    "timeSeen": "The last viewed time",
    "detail": "Detail"
  },
  "courseOnline": {
    "timeCourse": "Course duration",
    "comingSoon": "It will start soon",
    "title1": "The course you want to take is [XXXXX].",
    "title2": "It will take XX minutes to start this course.",
    "title4": "Do you want to join this course ?",
    "attendance": "Because this class has ended, you cannot attend. If you temporarily switch to another class and have finished studying, you can press [XXX] to take attendance for this course.",
    "comfirmRejoin": "Do you want to be took attendance for this class?",
    "join": "Take attendance",
    "reBegin": "Rejoin",
    "joinSuccess": "Attendance to the course was successful",
    "joinError": "Attendance to the course was failed",
    "btitle1": "[ XXX ① ] 又は [ XXX ② ]を押下すると講義に参加することができます。",
    "btitle2": "zoomアプリが開かれないなら[ XXX ① ] 又は [ XXX ② ]を押下してください。",
    "btitle3": "注意：この方法でアクセスすると本コースでは出席を取られない為、講義が終了後自分で出席を取ってください。",
    "draft": "予備",
    "courseName": "講義名称",
    "courseNameInput": "講義名称を入力してください。",
    "quantityAlert": "You cannot join the course because the number of students is full"
  },
  "notification": {
    "title1": "This is a notification of a course you have not started.",
    "title2": "Do you want to start the course to see the notification content?",
    "common": "You have got new notifications at",
  },
  "scoreStaticNew": {
    "noInformation": "There is no information for this student",
    "timeExamStart": "Started time of exam",
    "timeExamEnd": "Ended time of exam",
    "timeExamConducted": "Exam conducted time",
    "examDate": "Exam started date",
    "timeExamConductedNew": "Exam conducted time",
  },
  "manual": {
    "changeLanguage": "Change language",
    "searchCourse": "Search course",
    "personalInfo": "Personal information",
    "forgotPass": "Forgot password",
    "changeAva": "Change avatar",
    "changeInfo": "Change information",
    "changePass": "Change password",
    "commentNoti": "Comment Notification",
    "participation": "Participation course",
    "exercise": "Exercise",
    "markExercise": "Mark exercise",
    "midTerm": "Midterm exam",
    "finalExam": "Final exam",
    "achievements": "Achievements",
    "wrongList": "List wrong",
    "general": "General",
    "endCourse": "End course",
    "achievementStudent": "Achievement of student",
    "settingProcedure": "設定の手順書",
    "pwa": "スマホ用のマニュアル",
    "infoAcc": "account information",
    "jonhExam": "Take the exam",
  },
  "scoreNew": {
    "title1": "章節別の得点",
    "title2": "正解率",
    "title3": "得点率",
    "title4": "章名",
    "title5": "問題の総数",
    "title6": "正解の問題数",
    "title7": "不正解の問題数",
    "title8": "得点",
    "title9": "試験成績の出力",
    "title10": "成績詳細",
  },
  "manualNew": {
    "type_1": "はじめて利用する方へ",
    "type_1_1": "パソコンの場合",
    "type_1_2": "スマホ・タブレットの場合",
    "type_2": "ログイン・ログアウト",
    "type_2_1": "言語選択",
    "type_2_2": "ログイン",
    "type_2_3": "パスワード忘れた場合",
    "type_2_4": "ログアウト",
    "type_3": "コース受講",
    "type_3_1": "コース検索", 
    "type_3_2": "マイコース",
    "type_3_3": "コンテンツ閲覧",
    "type_3_4": "中間試験",
    "type_3_5": "修了試験",
    "type_3_6": "成績参照",
    "type_3_7": "誓約書",
    "type_3_8": "アンケート",
    "type_3_9": "メモリ出力",
    "type_3_10": "Completion application",
    "type_4": "学習状況",
    "type_4_1": "受講状況",
    "type_4_2": "成績状況",
    "type_5": "ライブ講義",
    "type_5_1": "講義検索",
    "type_5_2": "講義参加",
    "type_6": "プロファイル",
    "type_6_1": "プロファイル写真変更",
    "type_6_2": "情報変更",
    "type_6_3": "システム言語変更",
    "type_6_4": "パスワード変更",
    "type_7": "管理機能",
    "type_7_1": "管理対象者進捗状況参照",
    "type_7_2": "受講者管理",
    "type_7_3": "コース管理",
    "type_7_4": "出席情報",
    "type_7_5": "ライブ講義",
    "type_3_3_1": "♦ コースを開始する",
    "type_3_3_2": "♦ コースを選択する",
    "type_3_3_3": "♦ コンテンツを上下に移動する",
    "type_3_3_4": "♦ ズームイン/ズームアウト",
    "type_3_3_5": "♦ メモ",
    "type_3_3_6": "♦ コメント",
    "type_3_3_7": "♦ ページの遷移",
    "type_3_3_8": "♦ 小テスト",
    "type_3_3_9": "♦ 小テストの得点を表示する",
    "type_3_3_10": "♦ 戻る",
  },
  "codeStatus": {
    "code_1_99": "データなし",
    "code_1_0": "正常",
    "code_1_1": "未開始",
    "code_1_2": "有効期間外",
    "code_1_3": "依存コースはまだ完了していない",
    "code_1_4": "依存コースは学習完了したが、依存日数はまだ満たさない"
  },
  "online_ja": {
    "attendance1": "当ライブ講義は既に終了したため、ご参加できません。",
    "attendance2": "手動で出席を取りたい場合は、「XXX」ボタンにてお取りください。",
    "attendance3": "Web会議室を再利用したい場合は、「XXX」ボタンにてこのWeb会議室に入室してください。",
    "join": "出席取る",
    "cancel": "キャンセル",
    "rejoin": "再参加",
    "title": "確認",
    "title1": "「XXX」を押下することでライブ講義に参加してください。",
    "title2": "注意：ライブ講義のアプリケーションを開かなくて参加できない場合に、「XXX」ボタンを押下することでStudyArts経由せず、直接に参加して下さい。但し、直接参加する場合は自動的に出欠を取れないため、ライブ講義の終了後に再度出席を取って下さい。",
    "draft": "直参加",
    "clickJump": "参加",
  }
}
export default en;



// WEBPACK FOOTER //
// ./src/assets/languages/en.js